import React from "react";
import { MdDesignServices } from "react-icons/md";
import { myServices } from "../../../data/services";
import Heading from "../../reusable/Heading";
import ServiceCard from "./ServiceCard";
import useScrollReveal from "../../../hooks/useScrollReveal";
import css from "./services.module.css";

const Services = () => {
  const headingRef = useScrollReveal();

  return (
    <div style={{ paddingBottom: "7%" }} className="container px-lg-5">
      <div ref={headingRef} className="reveal">
        <Heading icon={<MdDesignServices />} headingTitle="What I Bring to the Team" />
      </div>

      <p className={css.sectionIntro}>
        Broad enough to connect the product, specialized enough to deliver each
        layer with care. Here is where I can contribute from the first sprint.
      </p>

      <div className="row g-4">
        {myServices.map((service, i) => (
          <div key={i} className="col-md-6">
            <ServiceCard service={service} index={i} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
